import { RepositoryBase } from '@app/repositories/RepositoryBase';

export class KilnStatusRepository<KilnStatusModel> extends RepositoryBase<KilnStatusModel> {
    public constructor() {
        super('kilnStatus');
    }
}
